import React, {useState} from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate, useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import successtone from "../success.mp3";
import errortone from "../error.mp3";



function WarehouseScannerPickup(){
const navigate = useNavigate();
const {type} = useParams();
const [slipno, setSlipno] = useState('');
const [scantype, setScantype] = useState(type);
const{headers1,headers2,logout}=AuthUser();
const courierselected = JSON.parse(localStorage.getItem('courierselectedoption'));
const [setloader, setSetloader] = useState(false);

const userdata = JSON.parse(localStorage.getItem('user'));
    
    const Globalreceiverslipno=()=>{
        if(scantype =='Manifested_Bag')
        {
            setSetloader(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'GlobalreceiverBagManifest',
                headers:headers1,
                data: {
                    userid:userdata.id,
                    usertype:userdata.usertype,
                    hub_name:userdata.hub_name,
                    branch_location:userdata.branch_location,
                    bag_id:slipno,

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    const audio = new Audio(successtone);
                    audio.play()
                    toast.success(response.data.message);
                }
                else
                {
                    const audio = new Audio(errortone);
                    audio.play()
                    toast.error(response.data.message);
                }
                setSetloader(false);
            })
            .catch(function (error) {
                setSetloader(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }
        else if(scantype =='Manifested_Shipment')
        {
            setSetloader(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'GlobalreceiverShipmentManifest',
                headers:headers1,
                data: {
                    userid:userdata.id,
                    usertype:userdata.usertype,
                    hub_name:userdata.hub_name,
                    branch_location:userdata.branch_location,
                    slip_no:slipno,
                    courierselected: courierselected

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    const audio = new Audio(successtone);
                    audio.play()
                    toast.success(response.data.message);
                }
                else
                {
                    const audio = new Audio(errortone);
                    audio.play()
                    toast.error(response.data.message);
                }
                setSetloader(false);
            })
            .catch(function (error) {
                setSetloader(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }
        else if (scantype === 'Schedule_Pickup') {
            setSetloader(true);
            axios({
                method: 'post',
                url: Global.baseUrl + 'checkscheduledPrsShipment',
                headers: headers1,
                data: {
                userid: userdata.id,
                usertype: userdata.usertype,
                hub_name: userdata.hub_name,
                branch_location: userdata.branch_location,
                slip_no: slipno,
                courierselected: courierselected
                }
            })
            .then(function (response) {

                setSetloader(false);

                if (response.data.status === 200) {

                const audio = new Audio(successtone);
                audio.play();

                toast.success(response.data.message);

                setTimeout(() => {
                    if(courierselected =='B2C')
                    {
                    navigate(`/ShipmentEdit/${slipno}`);
                    }
                    else{
                        navigate(`/GlobalShipmentb2bUpdate/${slipno}`);
                    }
                }, 1000);

                } else {

                const audio = new Audio(errortone);
                audio.play();

                toast.error(response.data.message);
                }
            })
            .catch(function (error) {

                setSetloader(false);

                if (error.response?.status === 401) {
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
                } else {
                toast.error("Server error");
                }
            });
            }
        else if(scantype =='Delivery')
        {
            alert("working pending");
        }
        else
        {
            setSetloader(false);
            axios({
                method: 'post',
                url: Global.baseUrl+'GlobalreceiverPickup',
                headers:headers1,
                data: {
                    userid:userdata.id,
                    usertype:userdata.usertype,
                    hub_name:userdata.hub_name,
                    branch_location:userdata.branch_location,
                    slip_no:slipno,
                    courierselected: courierselected

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    const audio = new Audio(successtone);
                    audio.play()
                    toast.success(response.data.message);
                }
                else
                {
                    const audio = new Audio(errortone);
                    audio.play()
                    toast.error(response.data.message);
                }
                setSetloader(false);
            })
            .catch(function (error) {
                setSetloader(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }
    }

const placeholderText =
  scantype === 'Manifested_Bag'
    ? 'Enter Bag Number'
    : courierselected === 'B2B'
    ? 'Enter LR Number'
    : 'Enter AWB Number';


    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer />
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-6 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Warehouse Inbound Scanner</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Warehouse Inbound Scanner</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                    
                </div>
            </div>


            <div className="row">
                <div className="col-12 col-md">
                    <div className="custom_nav_data_table warehouse_scanner">
                        <ul className="nav nav-tabs ">
                            <li className="nav-item ">
                              <a className={scantype == 'Pickup' ? 'nav-link active':'nav-link'} href="/WarehouseScanner/Pickup">
                                <h1><i className="bx bx-collection"></i></h1>
                                Scan Pickup Shipments
                              </a>
                            </li>
                            <li className="nav-item">
                              <a className={scantype =='Manifested_Bag' ? 'nav-link active':'nav-link'} href="/WarehouseScanner/Manifested_Bag">
                                <h1><i className="bx bx-cuboid"></i></h1>
                                Scan Manifested Bags</a>
                            </li>
                            <li className="nav-item">
                              <a className={scantype =='Manifested_Shipment' ? 'nav-link active':'nav-link'} href="/WarehouseScanner/Manifested_Shipment">
                                <h1><i className="bx bx bx-cube-alt"></i></h1>
                                Scan Manifeseted Shipments</a>
                            </li>
                            <li className="nav-item">
                              <a className={scantype =='Schedule_Pickup' ? 'nav-link active':'nav-link'} href="/WarehouseScanner/Schedule_Pickup">
                                <h1><i className="bx bx-run"></i></h1>
                                Scan Schedule Pickup</a>
                            </li>
                            {/* <li className="nav-item">
                              <a className={scantype =='Delivery' ? 'nav-link active':'nav-link'} href="/WarehouseScanner/Delivery">
                                <h1><i className="bx bx-run"></i></h1>
                                Scan Delivery Shipments</a>
                            </li> */}
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 col-md-3">
                    <h3 className="text-primary"><i className="bx bx-sun"></i></h3>
                    <ul className="scan_left">
                        <li>Arrival of shipments picked up by drivers or messengers into the warehouse</li>
                        <li>Barcode scanner to swiftly scan the barcode associated with each shipment.</li>
                        <li>Manually input the AWB (Air Waybill) number if scanning is not feasible.</li>
                        <li>Once the shipment details are entered, the system will integrate them into the warehouse inventory, facilitating seamless tracking and management.</li>
                    </ul>
                </div>
                <div className="col-12 col-md">
                    {scantype ==='Pickup' &&
                        <h3>Scan Pickup Shipments into Warehouse</h3>
                    }
                    {scantype ==='Manifested_Bag' &&
                        <h3>Scan Manifested Bags</h3>
                    }
                    {scantype ==='Manifested_Shipment' &&
                        <h3>Scan Manifeseted Shipments</h3>
                    }
                    {scantype ==='Schedule_Pickup' &&
                        <h3>Scan Schedule Pickup</h3>
                    }
                    {scantype ==='Delivery' &&
                        <h3>Scan Delivery Shipments</h3>
                    }
                    <div className="card px-5 py-3 mt-4">
                      <div className="card-body">
                        <div className="mb-2">
                        {scantype ==='Pickup' &&
                            <label htmlFor="exampleInputIconLeft">Scan Pickup Shipments</label>
                        }
                        {scantype ==='Manifested_Bag' &&
                            <label htmlFor="exampleInputIconLeft">Scan Manifested Bag</label>
                        }
                        {scantype ==='Manifested_Shipment' &&
                            <label htmlFor="exampleInputIconLeft">Scan Manifested Shipments</label>
                        }
                        {scantype ==='Schedule_Pickup' &&
                            <label htmlFor="exampleInputIconLeft">Scan Schedule Pickup</label>
                        }
                        {scantype ==='Delivery' &&
                            <label htmlFor="exampleInputIconLeft">Scan Delivery Shipments</label>
                        }
                            <div className="input-group input-group-lg">
                                <span className="input-group-text" id="basic-addon1">
                                <i className="bx bx-barcode"></i>
                                </span>
                                <input type="text" className="form-control form-control-lg" id="" value={slipno} onChange={(e)=>setSlipno(e.target.value)} placeholder={placeholderText} aria-label="Search" />
                            </div>
                        </div>
                        {setloader == false ? (
                        <div className="d-grid">
                          <button className="btn btn-primary btn-block" onClick={()=>Globalreceiverslipno()}>Submit</button>
                        </div>
                         ):(
                            <div>
                                <div className="d-grid">
                                    <a href="" className="btn btn-primary btn-lg btn-block disabled"> <span className="spinner"></span></a>
                                </div>
                            </div>
                        ) }
                      </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </main>
        </>

    );
}
export default WarehouseScannerPickup;